import { useNavigate } from "react-router-dom";

import bgImage from "../../../assets/images/The Process background.jpg";

import {
  Container,
  BackgroundImage,
  Inner,
  SectionTitle,
  CirclesRow,
  CircleStep,
  StepNumber,
  StepTitle,
  StepDesc,
  GetStartedButton,
} from "./styles";

const HowItWorksSection = () => {
  const navigate = useNavigate();

  return (
    <Container id="how-it-works">
      <BackgroundImage src={bgImage} alt="The process background" />
      <Inner>
        <SectionTitle>The process</SectionTitle>
        <CirclesRow>
          <CircleStep>
            <StepNumber>1</StepNumber>
            <StepTitle>Sign up</StepTitle>
            <StepDesc>to explore the top gyms and studios in your area</StepDesc>
          </CircleStep>
          <CircleStep>
            <StepNumber>2</StepNumber>
            <StepTitle>Train</StepTitle>
            <StepDesc>at one location and enjoy unlimited classes and amenities for one month</StepDesc>
          </CircleStep>
          <CircleStep>
            <StepNumber>3</StepNumber>
            <StepTitle>Decide</StepTitle>
            <StepDesc>if you found the right fit, stay or continue exploring, all in the app</StepDesc>
          </CircleStep>
        </CirclesRow>
        <GetStartedButton onClick={() => { navigate("/signup"); window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior }); }}>
          Get Started
        </GetStartedButton>
      </Inner>
    </Container>
  );
};

export default HowItWorksSection;
